import {
  TableRow,
  TableCell,
  Typography,
  Box,
  Button,
  Chip,
  CircularProgress,
  Checkbox,
  Tooltip,
} from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useState } from 'react';
import { runScenario } from '../../services/appFlowsService';
import { useSelector } from 'react-redux';
import { selectSelectedAppBuild } from '../../redux/app/platformSlice';
import { errorMessage } from '../../redux/locatorDrift/locatorDriftUtils';

export default function ScenarioRow({
  scenario,
  flowId,
  checked,
  onToggle,
  runStatus,
  selectedDevice,
}) {
  const [isRunning, setIsRunning] = useState(false);
  const isBlocked = runStatus === 'running' || runStatus === 'queued';
  const noDevice = !selectedDevice;
  const appBuild = useSelector(selectSelectedAppBuild);

  const handleRun = async () => {
    if (isBlocked || noDevice) return;

    try {
      setIsRunning(true);
      await runScenario(flowId, scenario.id);
    } catch (e) {
      console.error('Failed to run scenario', e);
      alert(`Failed to start scenario: ${errorMessage(e)}`);
    } finally {
      setIsRunning(false);
    }
  };

  const runTooltip = isBlocked
    ? 'Scenario is already running or queued'
    : noDevice
      ? 'Select a device first'
      : 'Run this scenario';

  return (
    <TableRow hover>
      <TableCell padding="checkbox">
        <Checkbox checked={checked} onChange={onToggle} disabled={isBlocked} size="small" />
      </TableCell>

      <TableCell>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="body2" fontWeight="medium">
            {scenario.id}
          </Typography>
          {runStatus === 'running' && <Chip label="Running" color="warning" size="small" />}
          {runStatus === 'queued' && (
            <Chip label="Queued" color="info" size="small" variant="outlined" />
          )}
        </Box>
      </TableCell>

      <TableCell>
        <Typography variant="body2">{scenario.title}</Typography>
      </TableCell>

      <TableCell align="right">
        <Tooltip title={runTooltip}>
          <span>
            <Button
              variant="contained"
              size="small"
              startIcon={isRunning ? <CircularProgress size={16} /> : <PlayArrowIcon />}
              disabled={isRunning || isBlocked || noDevice || !appBuild}
              onClick={handleRun}
            >
              Run
            </Button>
          </span>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
}
